import { FullSizeContainer } from '@mentimeter/visualizations-react/utils/full-size-container';
import { useRagnar } from '@mentimeter/ragnar-react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { SegmentedDots } from '@mentimeter/visualizations-react/visualizations/segmented-dots';
import type { SegmentedChoicesVisualizationProps } from '../types';
import { getColors } from '../../../shared/utils/getColors';

export const SegmentedDotsDataHandler = ({
  results,
  choices,
  shouldHideResults,
  shouldAnimate,
  showCorrect,
  shouldShowPercent,
  segmentation,
}: SegmentedChoicesVisualizationProps) => {
  const {
    theme: {
      visualizationColors: { fillColors, textColor, backgroundColor },
      fonts: { body },
    },
  } = useRagnar();

  const { results: currentResults, respondents } = results;

  // we need bigger set of colors for segmentation and we can't repeat them, so we need to expand with more variations
  const { barColors: segmentColors } = getColors(fillColors, backgroundColor);

  const segmentedData = currentResults.map((result) => ({
    id: result.id,
    scores: result.score,
  }));

  if (!segmentation.isSegmented) {
    return null;
  }

  return (
    <Box px="space2" width="100%" height="100%">
      <FullSizeContainer>
        {(width, height) => (
          <SegmentedDots
            sourceQuestionTitle={segmentation.segmentedQuestionTitle}
            segments={segmentation.segments}
            segmentKeyAccessor={(d) => d.position}
            width={width}
            height={height}
            colors={segmentColors as [string, ...string[]]}
            data={segmentedData}
            staticOptions={choices}
            disableAnimations={!shouldAnimate}
            isScoreHidden={shouldHideResults}
            textColor={textColor}
            fontFamily={body}
            shouldShowCorrect={showCorrect}
            shouldShowScorePercentage={
              shouldShowPercent ? { percentOf: respondents } : false
            }
          />
        )}
      </FullSizeContainer>
    </Box>
  );
};
